import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=4e410b72&scoped=true&"
import script from "./DataImport.vue?vue&type=script&lang=js&"
export * from "./DataImport.vue?vue&type=script&lang=js&"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=4e410b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e410b72",
  null
  
)

export default component.exports